export function destroyProductFruits() {
  window.productFruits?.services?.destroy()
}
